const getters = {
  // token: state => state.user.token,
  openId: state => state.user.openId,
  direction: state => state.settings.direction,
  loading: state => state.settings.loading
}
export default getters
